import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import IconEvent from '../../assets/icons/event.svg'

const UpcomingEventStyle = styled.div`
  height: 45px;
  background-color: #EDEEF3;
  color: #0B33F8;
  border-radius: 50px;
  display: grid;
  grid-template-columns: 28px max-content;
  grid-gap: 5px;
  padding: 0 20px;
  align-items: center;
  justify-content: center;
  float: right;

  img {
    width: 28px;
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: 28px min-content;
  }
`;

export default class UpcomingEvent extends Component {
  render() {
    const { data } = this.props;
    function elements2(value){
      return value.node.frontmatter.element === 2
    }
    return (
      <Link to={data.allMarkdownRemark.edges.filter(elements2)[0].node.fields.slug}>
        <UpcomingEventStyle>
          <img src={IconEvent} alt=""/>
          <h5>{data.allMarkdownRemark.edges.filter(elements2)[0].node.frontmatter.name}</h5>
        </UpcomingEventStyle>
      </Link>
    )
  }
}
